import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tehus',
  templateUrl: './tehus.component.html',
  styleUrls: ['./tehus.component.scss']
})
export class TehusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
